import image from 'shared/assets/images/integrationsSliders/outreach/outreach.png'
import { LINK_OUTREACH_INTEGRATION_GUIDE } from 'shared/constants/links'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const outreach: IntegrationDetailsData = {
  subheadline: 'Fuel your sales execution platform with comprehensive messaging intelligence.',
  overview:
    'Connect Salesmsg with Outreach to streamline your workflow and keep your sales execution platform up to date. When you engage with contacts through Salesmsg, relevant information flows to Outreach, ensuring your records stay current without manual data entry.',
  keyBenefits: [
    'Quick setup through the Salesmsg App Marketplace',
    'Reduce manual data entry and improve workflow efficiency',
    'Seamless integration between your messaging and sales execution workflows',
  ],
  images: [image],
  docs: LINK_OUTREACH_INTEGRATION_GUIDE,
}
